import React from 'react'
import PropTypes from 'prop-types'

import { Button } from './Button'
import { Modal as ReactModal } from 'react-bootstrap'

import '../../globals/scss/components/modal.scss'

const ModalDialog = (props) => {
  const { header, footer, children, ...modalProps } = props

  return (
    <ReactModal {...modalProps}>
      {header}
      <ReactModal.Body>{children}</ReactModal.Body>
      {footer ? (
        footer
      ) : (
        <ReactModal.Footer>
          <Button variant="text" onClick={modalProps.onHide}>
            <span className="material-icons">close</span>
            <span className="button__text">Close</span>
          </Button>
        </ReactModal.Footer>
      )}
    </ReactModal>
  )
}

ModalDialog.propTypes = {
  /** When true the modal will show itself. */
  show: PropTypes.bool.isRequired,
  /** A callback fired when the header closeButton or
   * non-static backdrop is clicked. Required if either
   *  are specified. */
  onHide: PropTypes.func.isRequired,
  /** The header of Modal */
  header: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element,
    PropTypes.func,
  ]),
  // PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /** The body of Modal */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element,
    PropTypes.func,
  ]),
  // PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /** The footer of Modal - Default footer is a Close button */
  footer: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element,
    PropTypes.func,
  ]),
  // PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
}

export const Modal = Object.assign(ModalDialog, {
  Title: ReactModal.Title,
  Header: ReactModal.Header,
  Body: ReactModal.Body,
  Footer: ReactModal.Footer,
})
